<template>
    <form>
        <form-alert />

        <div class="form-group">
            <label for="title">
                Title
            </label>
            <form-input
                v-model="mutableData.title"
                name="title"
                disabled
                data-vv-as="Title"
            />
        </div>

        <div class="form-group">
            <label for="content">
                Content
            </label>
            <trumbowyg
                v-model="mutableData.content"
                :config="config"
                disabled
                class="form-control"
                name="content"
                data-vv-as="Content"
            />
        </div>
    </form>
</template>

<script>
import Form from "../mixins/Form.js";
import Trumbowyg from "../mixins/Trumbowyg.js";

export default {
  mixins: [
    Form,
    Trumbowyg,
  ],
};
</script>
